<template>
  <section class="service-section">
    <div class="service-container">
      <ServicePackagesSidebar />
      <div class="content-col">
        <ServicePackageContent
          title="Portfolio Website Package"
          startingPrice="$5,999"
          :overview="overview"
          :bullets="bullets"
          :note="note"
          cta-route="/schedule-a-meeting"
        />
        <MobileServicePackagesList />
      </div>
    </div>
  </section>
</template>

<script>
import ServicePackagesSidebar from '@/views/servicePackages/ServicePackagesSidebar.vue';
import ServicePackageContent from '@/views/servicePackages/ServicePackageContent.vue';
import MobileServicePackagesList from '@/views/servicePackages/MobileServicePackagesList.vue';

export default {
  name: 'PortfolioWebsitePackage',
  components: { ServicePackagesSidebar, ServicePackageContent, MobileServicePackagesList },
  data() {
    return {
      overview:
        'We design modern portfolio websites that showcase your work and build credibility with prospects or employers. Using a flexible CMS template, this package is ideal for creatives, agencies, and professionals who want a polished, SEO-friendly portfolio fast.',
      bullets: [
        'A responsive, visually engaging site customized to your brand',
        'Portfolio or case study layouts to highlight your work',
        'CMS setup for simple content and project updates',
        'SEO-friendly setup to help your portfolio get discovered',
        'A clean design that puts your expertise front and center',
      ],
      note:
        'This package is template-driven with brand customization. For custom layouts and unique UX/UI design, pair it with our Custom UX/UI Design Package.',
    };
  },
};
</script>

<style scoped>
.service-section { padding: 2rem 1rem; background: #f9fafb; }

/* Two-column layout: fixed 380px sidebar + flexible content */
.service-container {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

/* Wrap content and ensure it can shrink without overflow */
.content-col { min-width: 0; }

/* One-column at ≤768px (sidebar hidden by its own CSS) */
@media (max-width: 768px) {
  .service-container {
    grid-template-columns: 1fr;
  }
}
</style>
